module.exports = __webpack_public_path__ + "img/bg-header-shape.26e06c19.svg";